import React from 'react';

const LogoHeaderReg = () => {
	return (
		<div className="main-header-div-top">
			<div className="title-div">
				<h1 className="title">tamar</h1>
				<div className="outer-circle">
					<div className="circle"></div>
				</div>
				<h1 className="title">dev</h1>
			</div>
		</div>
	);
};

export default LogoHeaderReg;
